import { render, staticRenderFns } from "./TicketsBoxesList.vue?vue&type=template&id=ac9fd58a&scoped=true"
import script from "./TicketsBoxesList.vue?vue&type=script&lang=js"
export * from "./TicketsBoxesList.vue?vue&type=script&lang=js"
import style0 from "./TicketsBoxesList.vue?vue&type=style&index=0&id=ac9fd58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9fd58a",
  null
  
)

export default component.exports